import { render, staticRenderFns } from "./LanderBenefits.vue?vue&type=template&id=4c078ddf&scoped=true&"
import script from "./LanderBenefits.vue?vue&type=script&lang=js&"
export * from "./LanderBenefits.vue?vue&type=script&lang=js&"
import style0 from "./LanderBenefits.vue?vue&type=style&index=0&id=4c078ddf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c078ddf",
  null
  
)

export default component.exports